import { mapActions, mapGetters } from "vuex"

export const mapMixin = {
  data() {
    return {

    }
  },
  mounted() {


  },


  //设置登录btn
  computed: {
    ...mapGetters(['token','sortVal','Categories','terminal','dataInfo','loginName','dataListTable','language'])
  },
  methods: {
    ...mapActions(['setToken','setSortVal','setCategories','setTerminal','setDataInfo','setLoginName','setDataListTable','setLanguage']),

  },
  watch: {

  },
  filters: {

  },


}